import { useTranslation } from 'react-i18next';
import { CheckboxInput, Col, Form, FormActions, Image, Modal, Row, Text, Title } from 'ui';

import type { InfoData } from '../../types';

const termsUrl = String(import.meta.env.VITE_APP_TERMS_URL);

export type InfoFormData = InfoData;

type P = {
  initialData?: InfoFormData;
  onSubmit: (values: InfoFormData) => void;
};

const SubscribeInfo = ({ initialData, onSubmit }: P) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<InfoFormData>();

  const initialValues: Partial<InfoFormData> = initialData ?? {};

  const handleFinish = (values: InfoFormData) => {
    onSubmit(values);
  };

  return (
    <Form<InfoFormData> className="subscribe-info" form={form} initialValues={initialValues} onFinish={handleFinish}>
      <Row>
        <Col className="subscribe-info__image">
          <Image
            preview={false}
            src="/assets/program/withings.jpg"
            srcSet="/assets/program/withings.jpg 1000w, /assets/program/withings.png 4000w"
          />
        </Col>
        <Col>
          <Title className="subscribe-info__title" level={3} marginBottom>
            By completing the following order, you will receive Health devices free of charge
          </Title>
        </Col>
        <Col className="subscribe-info__item">
          <Text>
            The devices will be delivered to your delivery address within two weeks. In the next steps it is necessary
            to enter your personal data, confirm the delivery address. The devices will be customized for you.
          </Text>
        </Col>
      </Row>

      <CheckboxInput
        item={{
          label: (
            <Text>
              {t('I agree to the')}{' '}
              <a href={termsUrl} rel="noopener noreferrer" target="_blank">
                {t('Terms & Conditions')}
              </a>
            </Text>
          ),
          name: 'terms',
          rules: [
            {
              validator: async (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error(t('Error: You must agree to the terms and conditions'))),
            },
          ],
          valuePropName: 'checked',
        }}
      />

      <CheckboxInput
        item={{
          label: t('I agree to receive commercial and marketing emails from Withings'),
          name: 'marketing',
          valuePropName: 'checked',
        }}
      />

      <Modal.HugContent.Footer>
        <FormActions submit={{ children: 'Continue' }} />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default SubscribeInfo;
